import React from 'react';
import { Link } from 'react-router-dom';

const RegisterForm: React.FC = () => {
  return (
    <div className="auth-container">
      <div className="auth-form">
        <h2>Registrering er stengt</h2>
        <p>Nye kontoer opprettes av en administrator. Kontakt en administrator hvis du trenger tilgang.</p>
        <div className="auth-link">
          <Link to="/login">Tilbake til innlogging</Link>
        </div>
      </div>
    </div>
  );
};

export default RegisterForm;
